<template>
  <div class="my-search" @click.stop :style="{ height: screenHeight + 'px' }">
    <AppNavBar
      :showTabBar="false"
      :back="false"
      :placeholder="true"
      :options="options"
    ></AppNavBar>
    <div class="s-top">
      <div class="back iconfont icon-fanhui" @click="bindBack"></div>
      <div class="search-content">
        <div class="search-icon iconfont icon-sousuo"></div>
        <div class="input-content">
          <van-field
            v-model="searchValue"
            :placeholder="placeholder"
            autofocus
            @input="bindInput"
            @focus="bindFocus"
          />
          <div class="clear-padding">
            <div
              class="clear iconfont icon-cha"
              v-show="searchValue !== ''"
              @click.stop="bindClear"
            ></div>
          </div>
        </div>
        <div class="s-text" v-show="!showResult" @click="bindSearch">搜索</div>
      </div>
    </div>
    <div class="bottom">
      <div class="default" v-show="showHistory">
        <SearchHistory
          :list="historyData"
          @delete="bindDeleteHistory"
          @search="bindSearch"
        />
        <SearchHot @search="bindSearch" />
      </div>
      <div class="word-list" v-show="showWordList">
        <SearchWordList
          :data="wordList"
          :word="searchValue"
          @search="bindSearch"
        />
      </div>
      <div class="result-list" v-if="showResult">
        <SearchResult
          ref="searchResult"
          :keyword="searchValue || placeholder"
          @search="bindSearch"
        />
      </div>
    </div>
    <van-overlay
      :show="showSelectMethods"
      @click="showSelectMethods = false"
      z-index="5001"
    >
      <SelectMethodsPopup
        :data="selectMethodsData"
        @add="bindAddBuji"
        @close="bindCloseSelectToast"
      />
    </van-overlay>
    <van-popup
      v-model="showTonicDetail"
      position="bottom"
      round
      class="plan-list-popup"
      z-index="5003"
    >
      <TonicDetail :id="tonicId" v-if="showTonicDetail" />
    </van-popup>
    <van-overlay :show="showCreateLoading" z-index="5002">
      <CreateLoading :type="loadingType" />
    </van-overlay>
  </div>
</template>

<script>
import { debounceLast } from '@/common/common.js'
import TonicDetail from './components/tonic-detail.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import SearchHistory from './components/search-history.vue'
import SearchHot from './components/search-hot.vue'
import SearchWordList from './components/search-word-list.vue'
import SearchResult from './components/search-result.vue'
import SelectMethodsPopup from './components/select-methods-popup.vue'
import CreateLoading from './components/create-loading.vue'
export default {
  components: {
    AppNavBar,
    SearchHistory,
    SearchHot,
    SearchWordList,
    SearchResult,
    SelectMethodsPopup,
    TonicDetail,
    CreateLoading
  },

  provide() {
    return {
      getHotData: () => this.hotData,
      getSearchValue: () => this.searchValue,
      addBuji: (item, index) => {
        this.bindAddBuji(item, index)
      },
      deleteBuji: (item) => this.bindDeleteBuji(item),
      clickTonicItem: (item) => {
        this.bindClickTonicItem(item)
      },
      submitPlan: () => {
        this.submitPlan()
      }
    }
  },
  data() {
    return {
      screenHeight: window.screen.height,
      loading: false,
      finished: false,
      page: 1,
      planId: '',
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)'
      },
      searchValue: '',
      placeholder: '',
      autoSearch: false,
      //搜索联想词列表
      wordList: [],
      /* 历史搜索 */
      historyData: [],
      /* 热点 */
      hotData: [],
      showWordList: false,
      showResult: false,
      showHistory: true,
      selectMethodsData: null, //选择补剂方案数据
      showSelectMethods: false,
      tonicId: 0,
      showTonicDetail: false,
      loadingType: 1,
      showCreateLoading: false
    }
  },
  computed: {
    curSelectList() {
      return this.$store.state.nutritionClock.selectList
    }
  },
  created() {
    this.placeholder = this.$route.query?.keyword || ''
    this.autoSearch = !!this.$route.query?.autoSearch
    this.planId = +this.$route.query?.planId || 0
    this.throttleWordList = debounceLast(this.getWordList, 800)
    this.getSearchHot()
    this.getHistoryData()
    if (this.autoSearch) {
      this.bindSearch()
    }
  },
  methods: {
    bindAddBuji(item, index) {
      this.showSelectMethods = false
      item.select = true
      item.curSelect = index
      this.$store.commit('nutritionClock/addSelectList', item)
    },
    bindDeleteBuji(item) {
      item.select = false
      item.curSelect = undefined
      this.$store.commit('nutritionClock/deleteSelectList', item)
    },
    bindClickTonicItem(item) {
      this.tonicId = item.product_id
      this.showTonicDetail = true
    },
    submitPlan() {
      if (this.planId) {
        this.editPlan()
      } else {
        this.createPlan()
      }
    },
    /* 编辑补剂计划 */
    async editPlan() {
      let list = this.filterSubmitData(this.curSelectList)
      let params = {
        detail: JSON.stringify(list),
        plan_id: this.planId
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/addUsageRule', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.resetSelectList()
          this.$toast('添加成功')
          setTimeout(() => {
            this.$router.go(-2)
          }, 500)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    resetSelectList() {
      this.$store.commit('nutritionClock/clearSelectList')
    },
    /* 创建补剂计划 */
    async createPlan() {
      this.loadingType = 1
      this.showCreateLoading = true
      let list = this.filterSubmitData(this.curSelectList)
      let params = {
        detail: JSON.stringify(list)
      }
      /* 动画播放时间 */
      let promise1 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      let promise2 = this.$http.postBaseApp(
        'api/v1/TonicPlanOperate/addCustomPlan',
        params
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {
        this.showCreateLoading = false
      })
      if (res) {
        let res1 = res[1].data
        if (res1.code == 200) {
          this.resetSelectList()
          /* 更新计划数据id */
          let planId = res1.data?.plan_id
          if (planId) {
            this.$store.commit('nutritionClock/setPlanDataId', planId)
          }
          this.backHome()
        } else {
          this.$toast(res1.msg)
          this.showCreateLoading = false
        }
      }
    },
    /* 返回首页 */
    backHome() {
      this.$store.commit('nutritionClock/setShowActivityToast', true)
      this.$router.go(-2)
    },
    bindCloseSelectToast() {
      this.showSelectMethods = false
    },
    bindAutoSearch() {
      this.bindSearch()
    },
    getHistoryData() {
      this.historyData =
        JSON.parse(localStorage.getItem('nutrition-clock-search-history')) || []
    },
    bindBack() {
      this.$http.appBack()
    },
    bindClear() {
      this.searchValue = ''
      this.showHistory = true
      this.showWordList = false
      this.showResult = false
    },
    filterSubmitData(data) {
      let res = data.map((item) => {
        let obj = {
          tonic_product_id: item.product_id,
          daily_times: item.usage[item.curSelect].daily_times,
          every_times_num: item.usage[item.curSelect].every_times_num,
          take_suggested_time: item.usage[item.curSelect].take_suggested_time,
          time_details: item.usage[item.curSelect].time_details
        }
        return obj
      })
      return res || []
    },
    bindInput(value) {
      if (value === '') {
        this.showHistory = true
      } else {
        this.showHistory = false
      }
      this.showResult = false
      this.showWordList = true
      this.throttleWordList(value)
    },
    bindFocus() {
      if (this.searchValue) {
        this.showResult = false
        this.showWordList = true
        this.showHistory = false
        this.throttleWordList(this.searchValue)
      }
    },
    bindDeleteHistory() {
      this.historyData = []
      localStorage.removeItem('nutrition-clock-search-history')
    },
    bindAddHistory(text) {
      if (this.historyData.includes(text)) {
        this.historyData.splice(this.historyData.indexOf(text), 1)
      }
      this.historyData.unshift(text)
      /* 限制最多20条 */
      this.historyData = this.historyData.slice(0, 20)
      localStorage.setItem(
        'nutrition-clock-search-history',
        JSON.stringify(this.historyData)
      )
    },
    //节流函数
    throttleFunc(callback, delayTime) {
      let timeId = undefined
      let self = this
      return function () {
        if (timeId !== undefined) {
          clearTimeout(timeId)
        }
        timeId = setTimeout(() => {
          callback.apply(self, arguments)
          timeId = undefined
        }, delayTime)
      }
    },
    bindSearch(value) {
      if (typeof value == 'string' && value) {
        this.searchValue = value
      }
      if (this.searchValue === '') {
        this.searchValue = this.placeholder
      }
      if (this.showResult) {
        this.$refs.searchResult.init()
      }
      this.showHistory = false
      this.showWordList = false
      this.showResult = true
      this.bindAddHistory(this.searchValue)
    },

    async getSearchHot() {
      let res = await this.$http
        .postBaseApp('api/v1/TonicShow/hotKeywords', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.hotData = res.data || []
        }
      }
    },
    async getWordList(value) {
      let params = { keywords: value }
      let res = await this.$http
        .postBaseApp('api/v2/Search/SearchAssociateTonicProduct', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          let data = res.data || []
          data.unshift({
            name: value,
            text: '点击搜索 ' + value
          })
          this.wordList = data
        }
      }
    },
    getRederList() {
      let list = this.data.map((item, index) => {
        let obj = {}
        let reg = RegExp(this.word, 'g')
        if (index == 0) {
          obj.text = item.text.replace(
            reg,
            '<span style="color:rgba(0, 205, 223, 1);">' + this.word + '</span>'
          )
        } else {
          obj.text = item.name.replace(
            reg,
            '<span style="color:rgba(0, 205, 223, 1);">' + this.word + '</span>'
          )
        }
        return obj
      })
      return list || []
    }
  }
}
</script>
<style lang="scss" scoped>
.my-search {
  color: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f9f9f9;

  .s-top {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .back {
      color: #000000;
      font-size: 20px;
      font-weight: bold;
      width: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .search-content {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 16px;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 17px;

      .input-content {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;

        .clear-padding {
          padding: 6px;
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0%, -50%);
        }

        .clear {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          color: #fff;
        }
      }

      ::v-deep .van-cell {
        padding: 5px;
      }

      ::v-deep .van-cell::after {
        display: none;
      }

      .search-icon {
        font-weight: bold;
        color: rgba(0, 0, 0, 0.5);
        margin-right: 8px;
      }

      .s-text {
        position: relative;
        padding: 0px 5px 0px 12px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        white-space: nowrap;
        font-weight: bold;
        font-size: 12px;
      }

      .s-text::after {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0%, -50%);
        width: 1px;
        height: 14px;
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .bottom {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;

    .default {
      padding: 16px;
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
    }

    .result-list {
      box-sizing: border-box;
      padding: 16px 0px 0px;
      height: 100%;
    }

    .word-list {
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
    }
  }
}
</style>
